import * as React from "react";
import styled from "styled-components";

/** StatuteBlockWrapper */
export const StatuteBlockWrapper = styled.div`
  margin-top: 80px;
  padding-bottom: 30px;
`;

/** Statute Section Header */
interface StatuteSectionHeaderProps {
  ordinal: number
  sectionName: string
}

export const StatuteSectionHeader = (props: StatuteSectionHeaderProps) => {
  const {ordinal,sectionName} = props;
  return (
    <div>
      <StyledParagraphSectionOrdinal>§ {ordinal}</StyledParagraphSectionOrdinal>
      <StyledParagraphSectionName>{sectionName}</StyledParagraphSectionName>
    </div>
  )
};

/** STYLES => StatuteSectionHeader */

const StyledParagraphSectionOrdinal = styled.h2`
  text-align: center;
  font-weight: bold;
  margin-bottom: 0;
`;

const StyledParagraphSectionName = styled.p`
  text-align: center;
  font-weight: bold;
  margin-top: 0;
  color: black;
`;

/** STYLES => ServiceStatuteBlock */
interface StatuteBlockProps {}

export class StatuteBlock extends React.Component<StatuteBlockProps,{}> {

  render() {
    return (
      <ParagraphSectionContentWrapper>
        <div>
          {this.props.children}
        </div>
      </ParagraphSectionContentWrapper>
    )
  }

}

const ParagraphSectionContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  color: black;
  div {
    width: 80%;
    max-width: 1100px;
    text-align: justify;
  }
  p {
  }
  strong {
    font-weight: bold;
  }
  ol {
    padding-left: 0;
    list-style-position: outside;
    li {
      margin-bottom: 12px;
      ol {
        padding-left: 15px;
        list-style-type: lower-alpha;
        list-style-position: outside;
        li {
          margin-bottom: 0;
        }
      }
      /* PODPUNKTY NUMEROWANE 1), 2), 3) (np. § 4 ust. 1 Polityki cookies) */
      ol.parenthesis-numbered {
        list-style-type: none;
        counter-reset: parenthesis-item;
        li {
          counter-increment: parenthesis-item;
          :before {
            content: counter(parenthesis-item) ") ";
          }
        }
      }
    }
  }
  a {
    color: #039be5;
    :visited {
      color: #039be5;
    }
  }
`;


// WEBPACK FOOTER //
// ./src/layouts/statute-block/statute-elements.tsx